/**
 * Loyalty user-profile
 */

import {fbLogin,assetFromRef} from '../utils/utils';

export default (function() {

    var ProfileView = Backbone.View.extend({
        initialize 	: function(){
            var _self = this;
            _.bindAll(this, 'updateModel');
            this.$target  = this.$('.xContentInner');
            this.listenTo(this.model, 'change', this.render);
            // as soon as we have an FB id update the model
            if (NGX.App.state.currentUser.fbid) {
                this.updateModel();
            } else {
                NGX.App.Events.once('fb:ready', function(){
                    fbLogin(_self.updateModel, { timing: 'now', scope:'' });
                });
            }
        },
        updateModel: function() {
            this.model.url = '/display/gamification/userProfile.json';
            this.model.fetch({
                data: {
                    apikey : NGX.context.apikey,
                    fbid   : NGX.App.state.currentUser.fbid,
                    cache  : Math.random(),
                    imageSize : (this.model.get('itemOpts'))?this.model.get('itemOpts')['imageSize']:{}
                }
            });
        },

        render: function(){
            var obj = this.model.attributes,
                template = NGX.App.api.getTemplate( this.model.get('template') );

            if (!obj.badges) obj.badges = 0;
            if (obj.level && obj.level.levelThumbnail) obj.levelThumbnail = assetFromRef(obj.level.levelThumbnail, NGX.context).src;

            if(obj.avatar){
                var avatarURL = obj.avatar.substr(0,obj.avatar.indexOf("?")+1),
                    theSize = this.model.get('itemOpts')['imageSize']?this.model.get('itemOpts')['imageSize']:'large';

                obj.avatar = avatarURL+"type="+theSize;
            }

            if (typeof template === 'function') {
                this.$target.html(template(obj))
            }
            return this;
        }
    });

    // register new view against a component type
    NGX.comps.push({type:'userprofile',  view:ProfileView});

}());